import { Loading } from 'element-ui'
export default {
  data() {
    return {
      showBtn: [//根据用户权限，判断用户是否有该功能，没有则隐藏其对应按钮
        {isShow:false,id:'search'},
        {isShow:false,id:'modify'},
        {isShow:false,id:'delete'},
        {isShow:false,id:'create'},
        {isShow:false,id:'import'},
        {isShow:false,id:'export'},
      ],
      //分页数据
      paging_data: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      },
      //地区数据
      area_data: {
        province: [],
        city: [],
        county: [],
        town: [],
        village: [],
      },
      province: '',
      city: '',
      county: '',
      town: '',
      village: '',
      editForm: {
        phone: '',
      },
      arrPlace: [],//放的是区域名，操作时避免相互干扰，赋值3份
      arrPlace1: [],
      arrPlace2: [],
      arrAreaId: [],
      form: {},
      form1: {},
      dis: [],
      lodaingTime: false,
      downShow: false,
      
      uploadUrl: this.$api.url_upload_pu,//工共文件上传地址
      publicFileUrl: ''//请求公共文件的url,后面只需要拼接文件的id,就可以获取上传的文件
    }
  },
  methods: {
    //关闭下载模板弹窗
    cutOff(bool) {
      this.downShow = bool
    },
    // 文件筛选
    Filter_file({ api, data, callback = () => {} } = {}) {
      // data.pageSize = 5
      let rD = { areaNames: [] }
      let area = [this.province, this.city, this.county, this.town, this.village]
      //过滤空字符串
      rD.areaNames = area.filter(x => x)
      console.log(rD)
      this.$api.changePlace(rD).then(res =>{
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          let areaId = _R[_R.length-1]
          if (areaId) {
            if (typeof data === 'object') {
              this.$api.getData(api, data).then(res2 => {
                if (res2.data.status === 0) {
                  let _R2 = JSON.parse(res2.data.data)
                  console.log(_R2)
                  
                  callback(_R2)
                  if (_R.length === 0) {
                    this.$message.warning('无相关信息')
                  }
                  this.paging_data.total = res2.data.size
                  this.paging_data.pageSize = res2.data.pageSize
                  // this.form.pageNumber = 1
                } else { this._status(res.data) }
              })
            } else { this.$message.warning('筛选参数必须为对象') }
          } else { this.$message.warning('请至少输入一个地区') }
        } else { this._status(res.data) }
      })
    },
    //导出数据
    Filter_export(api, data) {
      let rD = { areaNames: [] }
      let area = [this.province, this.city, this.county, this.town, this.village]
      //过滤空字符串
      rD.areaNames = area.filter(x => x)
      this.$api.changePlace(rD).then(res =>{
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          data.areaId = _R[_R.length-1]
          if (data.areaId) {
            let loadingInstance = Loading.service({
              lock: true,
              text: '导出中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)',
              fullscreen: true 
            })
            this.$api.getExport(api,data).then(res =>{
              if (res.data.status === 0) {
                this.$nextTick(() => {
                  loadingInstance.close()
                }) // 以服务的方式调用的 Loading 需要异步关闭
                this.$api.download_doc(res.data.data)
              } else { this._status(res.data) }
            })
          } else { this.$message.warning('请至少输入一个地区') }
        }
      })
    },

    // 获取地理位置
    getArea(data) {
      return this.$api.getPlace(data.value).then(res => {
        if (res.data.status === 0 ) {
          let _R = JSON.parse(res.data.data)
          switch(data.key) {
            case 0 :
              this.area_data.province = _R
              break
            case 1 :
              this.area_data.city = _R
              this.province = data.name
              this.city = this.county = this.town = this.village = ''
              break
            case 2 :
              this.area_data.county = _R
              this.city = data.name
              this.county = this.town = this.village = ''
              break
            case 3 :
              this.area_data.town = _R
              this.county = data.name
              this.town =  this.village = ''
              break
            case 4 :
              this.area_data.village = _R
              this.town = data.name
              this.village = ''
              break
            case 5 :
              this.village = data.name
              break
            default : break
          }
        } else { this.$message.error('获取失败') }
      })
    },
    getArea2(data) {
      console.log(data)
      this.$api.getPlace(data.value).then(res => {
        if (res.data.status === 0 ) {
          let _R = JSON.parse(res.data.data)
          switch(data.key) {
            case 0 : this.area_data.province = _R; break
            case 1 : this.area_data.city = _R; this.province = data.name; break
            case 2 : this.area_data.county = _R; this.city = data.name;  break
            case 3 : this.area_data.town = _R; this.county = data.name;  break
            case 4 : this.area_data.village = _R; this.town = data.name;  break
            case 5 : this.village = data.name;  break
            default : break
          }
        } else { this.$message.error('获取失败') }
      })
    },
    //设置默认地址
    getDefault() {
      let { admin, areaId } = this.userInfo
      if (admin) {
        for (let i = 0; i < 5; i++) { this.dis.push(false) }
      } else {
        return this.$api.getFather({ areaId }).then(res => {
          if (res.data.status === 0) {
            let _R = JSON.parse(res.data.data)
            console.log(_R)
            _R.forEach((x, i) => {
              this.arrPlace1[x.level] = x.name
              this.arrPlace[x.level] = x.name
              this.arrPlace2[x.level] = x.name
              this.dis[x.level] = i !== 4
              // this.arrPlace1.push(x.name)
              // this.arrPlace.push(x.name)
              // this.arrPlace2.push(x.name)
              // i === 4 ? this.dis.push(false) : this.dis.push(true)
              switch(x.level) {
                case 0 : this.form.province = x.name; break
                case 1 : this.form.city = x.name; break
                case 2 : this.form.county = x.name; break
                case 3 : this.form.town = x.name; break
                case 4 : this.form.village = x.name; break
                default : break
              }
            })
            this.setPlace(this.form, 'search')
          } else { this._status(res.data) }
        })
      }
    },
    // 自定义事件获取位置
    getPlace(data) { this.getArea(data) },
    // 自定义事件获取位置(搜索) 存储搜索条件的地址name到form，解决修改弹框与搜索列的组件冲突
    async getPlace1(data) {
      // this.fareaId = data.value.areaId
      switch(data.key) {
        case 1 : this.form.province = data.name; break
        case 2 : this.form.city = data.name; break
        case 3 : this.form.county = data.name; break
        case 4 : this.form.town = data.name; break
        case 5 : this.form.village = data.name; break
      }
      await this.getArea(data)
    },
    // 自定义事件获取位置(搜索) 存储搜索条件的地址name到form，解决修改弹框与搜索列的组件冲突 导出表事件
    getPlace2(data) {
      switch(data.key) {
        case 1 : this.form1.province = data.name; break
        case 2 : this.form1.city = data.name; break
        case 3 : this.form1.county = data.name; break
        case 4 : this.form1.town = data.name; break
        case 5 : this.form1.village = data.name; break
      }
      this.getArea(data)
    },
    // 用地址名查对应id，返回id用来查下拉框数据
    setPlace(data, str) {
      let rD = { areaNames: [] }
      rD = { areaNames: [ data.province, data.city, data.county, data.town, data.village ] }
      this.$api.changePlace(rD).then(res =>{
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          if (str === 'search') {
            this.arrPlace1 = _R
            this.arrPlace1.forEach((x, i) => {
              this.getArea2({ value: { areaId: x }, key: (i + 1), name: rD.areaNames[i] })
            })
          } else {
            this.arrPlace = _R
            let areaArr = []
            areaArr[0] = data.province
            areaArr[1] = data.city
            areaArr[2] = data.county
            areaArr[3] = data.town
            areaArr[4] = data.village
            this.arrPlace.forEach((x, i) => { 
              this.getArea2({ value: { areaId: x }, key: (i + 1), name: areaArr[i] })
            })
          }
        } else { this._status(res.data) }
      })
    },
    // 控制模块的操作按钮是否显示
    isShowBtn(str) {
      this.showBtn.forEach(x => {//所有按钮显示重置为false
        x.isShow = false
      })
      if (this.userInfo.admin === false) {//不是管理员
        let privilegesList = this.userInfo.privilegesList
        this.showBtn.forEach(x => {
          if (privilegesList.indexOf(str+'-'+x.id) != -1) {
            x.isShow = true
          }
        })
      } else {
        this.showBtn.forEach(x => {
          x.isShow = true
        })
      }
    },
    //请求公共文件的url,后面只需要拼接文件的id,就可以获取上传的文件
    getPublicFileUrl() {
      this.$api.getPublicFileUrl().then(res => {
        this.publicFileUrl = res.data.data
      })
    },
    //打开弹框
    openBox(str) {
      this.editForm = {}
      this.fileList = [] //默认头像为空
      this.fileListArr = [] //默认套图为空
      this.isMax = false //头像添加图片默认显示
      this.isArrMax = false //套图添加图片默认显示
      this.headImgId = ''
      this.videoUrl = ''
      if (str === 'edit') {
        this.isCreate = false
        this.editForm = JSON.parse(JSON.stringify(this.selectRow[0]))
        delete this.editForm.createTime
        this.editForm.layType ? this.createLaytype = this.editForm.layType :this.createLaytype=[]
        console.log(this.editForm)
        // console.log(this.selectRow[0],this.editForm)
        //头像回显
        if (this.editForm.imgUrl != '' ) {//选中的对象有imgUrl的属性且不为空，就让图片回显&& ('imgUrl' in this.editForm)
          this.fileList = [{name: this.editForm.imgUrl+'.jpg', url: this.publicFileUrl + '/' + this.editForm.imgUrl}]
          this.isMax = true
          this.headImgId = this.editForm.imgUrl
        } else {
          this.isMax = false
        }
        if (this.editForm.showUrls) {
          this.ImgIdArr = this.editForm.showUrls
          //套图回显
          if (this.editForm.showUrls.length != 0 ) {
            this.editForm.showUrls.forEach( (x,index) => {
              this.fileListArr[index] = {id:x,url:this.publicFileUrl + '/' + x}
            })
            if (this.editForm.showUrls.length == 5) {
              this.isArrMax = true
            }
          }
        }
        // 视频回显
        if (this.editForm.videoUrl != '') {
          this.videofileList = [{name:'个人简介.mp4',url:this.editForm.videoUrl}]
          this.videoUrl = this.editForm.videoUrl
        } else {
          this.videofileList=[]
        }
        this.setPlace(this.editForm)
        // console.log(111,this.arrPlace1)
      } else {
        console.log(this.editForm)
        this.isOutUrl = false
        this.ImgIdArr = []
        this.fileList = []
        this.isCreate = true
        this.imageUrl1 = ''
        this.videoUrl = ''
        this.videofileList=[]
        // this.arrPlace = []
        this.userInfo.admin ? this.arrPlace = [] : this.setPlace(this.form)
      }
      this.centerDialogVisible = true
    },
    //关闭弹框回调
    close() {
      this.clearPlace()
      //清空日志
      this.logType = 1,
      this.logImg = [],
      this.serviceContent = '',
      this.serviceResult = '',
      this.activeName = '结对帮扶',
      this.isCreate = false ? 
      this.$refs.uploadImg.forEach(x => {
        x.clearFiles()
      }) : ''
      // console.log(this.form)
      // console.log(this.form1)
      // //恢复筛选得地址
      // this.setPlace(this.form,'search')
      // this.setPlace(this.form1,'search')
    },
    //置空遗留地址
    clearPlace() {
      this.province = ''
      this.city = ''
      this.county = ''
      this.town = ''
      this.village = ''
    },

    init() {//在页面初始渲染的时候，默认查询的数据====根据账号绑定的区域id                   后台  服务常调用的方法
      let areaId = this.userInfo.areaId
      this.getData({areaId})
    },

    //后台 服务方面的 分页
    get_page_number(pageNumer) {
      this.paging_data.currentPage = pageNumer
      this.filterClick()
    },

    getAreaidAndData(newForm) {//后台服务页面点击查询时，传入筛选对象，此时还没有区域id       后台  服务常调用的方法
      let rD = { areaNames: [ this.province, this.city, this.county, this.town, this.village ] }
      this.$api.changePlace(rD).then(res => {
        if (res.data.status === 0) {
          let id = JSON.parse(res.data.data)
          newForm.areaId = id[id.length - 1]
          console.log(newForm.areaId)
          //以上都为拿到筛选区域的区域id和筛选条件的对象的其他属性
          this.getData(newForm)
        } else {
          this._status(res.data)
        }
      })
    },

    deletefuwuData(str) {//后台删除 服务  中的数据
      let ids = this.selectRow.map(x => x.id)
      this.selectRow.length === 0  
        ? this.$message.error('请至少勾选一条数据') 
        : this.$confirm('确认删除数据?','提示',{ confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
          let rD = { ids }
          this.$api.util_delete(str, rD).then(res => {
            if (res.data.status === 0 ) {
              this.$message.success('删除成功!')
              this.paging_data.total = this.paging_data.total - ids.length
              if (this.paging_data.total % this.paging_data.pageSize === 0) {//把当前页的所有数据都删除时，需要更换页码
                if (this.paging_data.currentPage > 1) {
                  this.paging_data.currentPage--
                } else {
                  this.paging_data.currentPage = 1
                }
              }
              console.log('删除之后的总条数',this.paging_data.total,'当前页数',this.paging_data.currentPage)
              this.getData()
            } else { this._status(res.data) }
          })
        }).catch(() => {})
    },

    deleteHandler(str) {
      let ids = this.selectRow.map(i => i.id)
      if (this.selectRow.length > 0) {
        this.$confirm('确认删除数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.util_delete(str, {ids}).then(res => {
            if (res.data.status == 0) {
              this.$message.success('删除成功!')
              this.paging_data.total = this.paging_data.total - ids.length
              if (this.paging_data.total % this.paging_data.pageSize === 0) {//把当前页的所有数据都删除时，需要更换页码
                if (this.paging_data.currentPage > 1) {
                  this.paging_data.currentPage--
                } else {
                  this.paging_data.currentPage = 1
                }
              }
              this.getData ? this.getData() : this.Filter_file({api:this.api,data: this.form,callback:_d=>this.tableData=_d})
            } else { this._status(res.data) }
          })
        }).catch(() => {})
      } else { this.$message.error('请至少勾选一条数据') }
    },

    //后台  文章  方面的分页
    get_page_number_article(pageNumer) {
      this.paging_data.currentPage = pageNumer
      this.filterClickNews()
    },

    // 发布文章相关组件渲染时调用，区别于筛选函数，是要取分是否为管理员
    firstGetNews() {
      if (this.userInfo.admin) {//是管理员
        // this.filterClickNews()
      } else {//不是管理员
        this.editForm = this.defaultEditForm
        let rD = {}
        rD = JSON.parse(JSON.stringify(this.filterForm))
        rD.areaId = this.userInfo.areaId
        this.getChenjNews(rD)
      }
    },
    // 点击查询    文章方面
    filterClickNews() {
      this.editForm = this.defaultEditForm
      let rData = {}
      // this.paging_data.currentPage = 1

      rData = JSON.parse(JSON.stringify(this.filterForm))
      rData.title == '' ? delete rData.title : ''
      
      if (this.province) {
        let rD = { areaNames: [ this.province, this.city, this.county, this.town, this.village ] }
        // console.log(rD)
        this.$api.changePlace(rD).then(res =>{
          if (res.data.status === 0) {
            let id = JSON.parse(res.data.data)
            rData.areaId = id[id.length - 1]
            this.getChenjNews(rData)
            //以上都为拿到筛选区域的区域id和筛选条件的对象的其他属性
            // this.getData(rData)
          } else { this._status(res.data) }
        })
      } else { this.$message.warning('请选择地区') }
    },

    // 查询    文章数据
    getChenjNews(rData) {
      rData.includeParentSite = true
      rData.pageNumber = this.paging_data.currentPage
      // console.log('筛选条件',rData)
      this.$api.util_search('xinwen', rData).then(res =>{
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          this.paging_data.total = res.data.size
          this.tableData = _R
          console.log('请求回来的数据',this.tableData)
          if (_R.length !== 0) {
            this.tableData = _R.map(x => {
              x.areaName = x.province + x.city + x.county + x.town + x.village
              return x
            })
            this.editForm = JSON.parse(JSON.stringify(this.tableData[0]))
          } else {
            this.$message.warning('该区域暂无相关信息')
            // this.editForm = this.defaultEditForm
            let areaName = this.province + this.city + this.county + this.town + this.village
            // this.editForm.areaName = areaName
            this.$set(this.editForm, 'areaName', areaName)
            console.log(this.editForm)
          }
        } else { this._status(res.data) }
      })
    },
    // 撤销修改信息    文章方面  针对于只显示1篇文章的页面
    rvoke() {
      if (this.tableData.length) {
        let rD = {}
        this.editForm.title != this.tableData[0].title ? rD.title = this.editForm.title : ''
        this.editForm.description != this.tableData[0].description ? rD.description = this.editForm.description : ''
        this.editForm.content != this.tableData[0].content ? rD.content = this.editForm.content : ''
        if (JSON.stringify(rD)=='{}') {
          this.$message.info('您未修改任何信息')
        } else {
          this.$confirm('确认将修改的信息复原吗？?', '确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.editForm = JSON.parse(JSON.stringify(this.tableData[0]))
          }).catch(() => {})
        }
      }
    },

    // 保存或修改信息   为后台文章页面调用，而且是只显示1篇文章的页面才调用这个方法，无添加功能，有新建和修改，
    submitNews() {
      this.$refs['editForm'].validate((valid)=>{
        if (valid) {
          if (this.tableData.length==0) {//判断为新建信息
            let newForm = JSON.parse(JSON.stringify(this.editForm))
            newForm.province = this.province
            newForm.city = this.city
            newForm.county = this.county
            newForm.town = this.town
            newForm.village = this.village
            console.log(newForm)
            if (newForm.province =='') {
              this.$message.info('请选择地区')
            } else {
              console.log(newForm.content)
              this.$api.util_create('xinwen', newForm).then(res =>{
                if (res.data.status === 0) {
                  this.$message.success('保存成功！')
                  this.getChenjNews(this.defaultEditForm)
                } else {
                  this._status(res.data)
                }
              })
            }
          } else {//判断为修改信息
            let rD = {}
            this.editForm.title != this.tableData[0].title ? rD.title = this.editForm.title : ''
            this.editForm.description != this.tableData[0].description ? rD.description = this.editForm.description : ''
            this.editForm.content != this.tableData[0].content ? rD.content = this.editForm.content : ''
            if (JSON.stringify(rD)=='{}') {
              this.$message.info('您未修改任何信息,无需保存')
            } else {
              rD.id = this.editForm.id
              this.$api.util_modify('xinwen', rD).then(res =>{
                if (res.data.status === 0) {
                  this.$message.success('修改成功！')
                  // this.filterClickNews()
                } else { this._status(res.data) }
              })
            }
            
          }
        } else {
          return false
        }
      })
    },

    // 添加或修改信息  文章方面 文章是以表格形式展示的页面调用下面的方法，有添加的功能
    submitArticles() {
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          if (this.isOutUrl) {//创建的是外部文章
            this.editForm.content == ''
          } else {//创建的是内部文章
            this.editForm.outUrl == ''
          }
          let newForm = {}
          newForm = JSON.parse(JSON.stringify(this.editForm))
          newForm.province = this.province
          newForm.city = this.city
          newForm.county = this.county
          newForm.town = this.town
          newForm.village = this.village
          newForm.catalog = this.defaultEditForm.catalog//文章属于什么类型
          console.log('创建数据',newForm)
          if (newForm.province =='') {
            this.$message.info('请选择地区')
          } else {
            this.$api.util_create('xinwen', newForm).then(res =>{
              if (res.data.status === 0) {
                this.$message.success('保存成功！')
                this.filterClickNews(this.defaultEditForm)
                this.centerDialogVisible = false//隐藏弹框
              } else { this._status(res.data) }
            })
          }
        } else if (valid && this.isCreate === false) {
          if (this.isOutUrl) {//创建的是外部文章
            this.editForm.content == ''
          } else {//创建的是内部文章
            this.editForm.outUrl == ''
          }
          let rD = {}
          let mapList = ['content','title','description','outUrl','srcFrom']
          mapList.forEach(x =>{
            this.selectRow[0][x] != this.editForm[x] ? rD[x] = this.editForm[x] : ''
          })
          if (JSON.stringify(rD) == '{}') {
            this.$message.info('您未修改任何信息！')
          } else {
            rD.id = this.selectRow[0].id
            this.$api.util_modify('xinwen', rD).then(res =>{
              if (res.data.status === 0) {
                this.$message.success('保存成功！')
                this.filterClickNews(this.defaultEditForm)
                this.centerDialogVisible = false//隐藏弹框
              } else { this._status(res.data) }
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除文章，只有在后台以表格的形式展示的文章才能被删除
    deleteArticles() {
      let ids = this.selectRow.map(i => i.id)
      this.selectRow.length === 0  
        ? this.$message.error('请至少勾选一条数据') 
        : this.$confirm('确认删除数据?','提示',{ confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
            this.$api.util_delete('xinwen', {ids}).then(res => {
              if (res.data.status === 0 ) {
                this.$message.success('删除成功!')
                this.filterClickNews()
              } else { this._status(res.data) }
            })
          }).catch(() => { this.$message.info('已取消删除') })
    },



    //前端页面   右边的小表单提交,提交互动交流和投诉举报
    rightFormSubmit(content, title) {
      if (content == '') {
        this.$message.error('请填写内容后再提交！')
      } else {
        if (title === '互动交流') {
          console.log('内容', content)
        } else {//投诉
          console.log('内容', content, '律师',this.layerData, '公司',this.companyData, '详情',this.detailData)
          
          let userId = this.userInfo.id
          let areaId = JSON.parse(localStorage.getItem('checkedArea')).id
          let route = this.$route.name
          let targetId = this.companyId
          let subName = ''

          if (['detail','detailList'].includes(route) && !this.companyData) {
            this.$message.warning('企业信息不完善！')
            return
          } else {
            switch (route) {
              case 'detail':
                targetId = this.companyData.id || this.detailData.id
                subName = this.detailData.name
              break
              case 'detailList':
                targetId = this.companyData.id
                subName = this.companyData.name
              break
              case 'layerDetail':
                targetId = this.layerData.ownerId
                subName = this.layerData.name
              break
            }

            let rD = {
              areaId,
              targetId,
              subName,
              userId,
              content,
            }
            console.log(rD)
            this.$api.util_create('tousu', rD).then(res => {
              if (res.data.status == 0) {
                this.$message.success('投诉成功！')
              } else { this._status(res.data) }
            })
          }
        }
      }
    },
  },
  created() {
    if (typeof(localStorage.loginData) != 'undefined') {
      this.getDefault()
    }
    this.getPublicFileUrl()
  },
}